import CustomerNonReturning from '../../Custom/Main/Customer/CustomerNonReturning';
import DashboardHeader from '../../Common/DashboardHeader';
import { useEffect, useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import axiosInstance from '../../../../services/AxiosInstance';
import Api from '../../../../constants/Api';
import { useBranch } from '../../../../context/BranchContext';
import './NonReturningCustomers.css';

const OverviewCard = ({ label, value, detail, icon, tone }) => (
    <div className={`customer-overview-card customer-overview-card--${tone}`}>
        <div className="customer-overview-card__header">
            <span>{label}</span>
            <div className="customer-overview-card__icon">
                <i className={`fa-solid ${icon}`}></i>
            </div>
        </div>
        <strong>{value}</strong>
        <p>{detail}</p>
    </div>
);

const formatPercent = (value) => `${Number(value || 0).toFixed(1)}%`;

const NonReturningCustomers = () => {
    const { selectedBranch } = useBranch();
    const [selectedDays, setSelectedDays] = useState(30);
    const [customerTotals, setCustomerTotals] = useState({
        totalOverall: 0,
        totalCurrent: 0,
        totalPrevious: 0,
        percentage: 0
    });
    const [birthdayTotal, setBirthdayTotal] = useState(0);
    const [retentionStats, setRetentionStats] = useState({
        total: 0,
        critico: 0,
        alto: 0,
        medio: 0,
        baixo: 0,
        avgDays: 0
    });

    const periodOptions = [
        { days: 15, label: '15 dias' },
        { days: 30, label: '30 dias' },
        { days: 60, label: '60 dias' },
        { days: 90, label: '90 dias' },
        { days: 180, label: '6 meses' }
    ];

    useEffect(() => {
        const branchId = selectedBranch ? selectedBranch.id : -1;

        axiosInstance.get(`${Api.main.customer}/total/${branchId}`)
            .then((response) => {
                setCustomerTotals(response.data || {
                    totalOverall: 0,
                    totalCurrent: 0,
                    totalPrevious: 0,
                    percentage: 0
                });
            });

        axiosInstance.get(`${Api.main.customer}/total/birthdays/${branchId}`)
            .then((response) => setBirthdayTotal(response.data || 0));
    }, [selectedBranch]);

    const retentionCoverage = customerTotals.totalOverall
        ? (retentionStats.total / customerTotals.totalOverall) * 100
        : 0;


    return (
        <>
            <div className="customer-dashboard">
                {/* Os três indicadores que ficavam aqui já existem abaixo: o total e a
                    quebra por risco estão na carteira de retenção, e a janela ativa é o
                    próprio botão selecionado no filtro logo em seguida. */}
                <DashboardHeader
                    compact
                    title="Clientes não retornantes"
                >
                    <div className="customer-retention-period-label">
                        <i className="fa-solid fa-calendar-days"></i>
                        <div>
                            <strong>Janela sem retorno</strong>
                            <span>Considere clientes sem compra ou atendimento há mais de:</span>
                        </div>
                    </div>

                    <div className="dashboard-filters__quick">
                        {periodOptions.map((option) => (
                            <button
                                key={option.days}
                                type="button"
                                className={`dashboard-chip ${selectedDays === option.days ? 'is-active' : ''}`}
                                aria-pressed={selectedDays === option.days}
                                onClick={() => setSelectedDays(option.days)}
                            >
                                {option.label}
                            </button>
                        ))}
                    </div>
                </DashboardHeader>

                <Row className="g-3 mb-4">
                    <Col xl={3} md={6}>
                        <OverviewCard
                            label="Base total"
                            value={customerTotals.totalOverall}
                            detail="clientes cadastrados na base"
                            icon="fa-users"
                            tone="sky"
                        />
                    </Col>
                    <Col xl={3} md={6}>
                        <OverviewCard
                            label="Novos no mês"
                            value={customerTotals.totalCurrent}
                            detail={`${formatPercent(customerTotals.percentage)} vs. período anterior`}
                            icon="fa-user-plus"
                            tone="green"
                        />
                    </Col>
                    <Col xl={3} md={6}>
                        <OverviewCard
                            label="Aniversariantes hoje"
                            value={birthdayTotal}
                            detail="clientes e colaboradores com data no dia"
                            icon="fa-cake-candles"
                            tone="amber"
                        />
                    </Col>
                    <Col xl={3} md={6}>
                        {/* "Cobertura" sugeria proteção; o número é o oposto disso, a fatia
                            da base que parou de voltar. O denominador é a base ativa da
                            filial, e o numerador só inclui quem já comprou alguma vez. */}
                        <OverviewCard
                            label="Base em risco"
                            value={formatPercent(retentionCoverage)}
                            detail={`${retentionStats.total} de ${customerTotals.totalOverall} clientes sem retornar`}
                            icon="fa-heart-crack"
                            tone="coral"
                        />
                    </Col>
                </Row>

                <CustomerNonReturning
                    days={selectedDays}
                    onStatsChange={setRetentionStats}
                />
            </div>
        </>
    );
};

export default NonReturningCustomers;
